import * as React from "react";
import { TransformGroup } from "./TransformGroup";

const Right = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5758 4.57554C10.3415 4.80987 10.3415 5.18977 10.5759 5.42407L12.5514 7.39941H2.0001C1.66873 7.39941 1.4001 7.66804 1.4001 7.99941C1.4001 8.33078 1.66873 8.59941 2.0001 8.59941H12.5518L10.5758 10.5758C10.3415 10.8101 10.3415 11.19 10.5759 11.4243C10.8102 11.6586 11.1901 11.6586 11.4244 11.4242L14.4244 8.42364C14.6587 8.1893 14.6587 7.80942 14.4243 7.57512L11.4243 4.57549C11.19 4.34119 10.8101 4.34121 10.5758 4.57554Z"
    />
);

const Left = () => (
    <TransformGroup rotation="reverse">
        <Right />
    </TransformGroup>
);

const RightShort = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.57583 2.57576C8.34152 2.81007 8.34152 3.18997 8.57583 3.42429L12.5516 7.40002H2.0001C1.66873 7.40002 1.4001 7.66865 1.4001 8.00002C1.4001 8.3314 1.66873 8.60002 2.0001 8.60002H12.5516L8.57583 12.5758C8.34152 12.8101 8.34152 13.19 8.57583 13.4243C8.81015 13.6586 9.19005 13.6586 9.42436 13.4243L14.4244 8.42429C14.6587 8.18997 14.6587 7.81007 14.4244 7.57576L9.42436 2.57576C9.19005 2.34145 8.81015 2.34145 8.57583 2.57576Z"
    />
);

const LeftShort = () => (
    <TransformGroup rotation="reverse">
        <RightShort />
    </TransformGroup>
);

const SyncHorizontal = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.3999 11C2.3999 10.6686 2.66853 10.4 2.9999 10.4L11.5514 10.4L9.57564 8.42424C9.34132 8.18993 9.34132 7.81003 9.57564 7.57571C9.80995 7.3414 10.1899 7.3414 10.4242 7.57571L13.4242 10.5757C13.6585 10.81 13.6585 11.1899 13.4242 11.4242L10.4242 14.4242C10.1899 14.6586 9.80995 14.6586 9.57564 14.4242C9.34132 14.1899 9.34132 13.81 9.57564 13.5757L11.5514 11.6L2.9999 11.6C2.66853 11.6 2.3999 11.3313 2.3999 11ZM2.57564 5.42424C2.34132 5.18992 2.34132 4.81003 2.57564 4.57571L5.57564 1.57571C5.80995 1.3414 6.18985 1.3414 6.42417 1.57571C6.65848 1.81003 6.65848 2.18992 6.42417 2.42424L4.44843 4.39997L12.9999 4.39997C13.3313 4.39997 13.5999 4.6686 13.5999 4.99998C13.5999 5.33135 13.3313 5.59998 12.9999 5.59998L4.44843 5.59998L6.42417 7.57571C6.65848 7.81003 6.65848 8.18993 6.42417 8.42424C6.18985 8.65855 5.80995 8.65855 5.57564 8.42424L2.57564 5.42424Z"
    />
);

export const Arrow = {
    RightShort,
    LeftShort,
    Right,
    Left,
    SyncHorizontal,
};
